module.exports = __webpack_public_path__ + "img/advanced-electronics.3973f6d8.png";